module.exports = __webpack_public_path__ + "static/media/flag3.95ea2633.svg";